// extracted by mini-css-extract-plugin
module.exports = {"nav-pills-vertical":"style_nav-pills-vertical__DZnA0","nav-item":"style_nav-item__M2la_","nav-link":"style_nav-link__1MNjB"};